import RemoveItem from "./remove-item";

export default RemoveItem;